<template>
    <div class="py-3">
        <div class="d-flex justify-content-between mb-4 h3">
            <div class="header-container">
                <img src="../../../assets/images/title-icon.png" alt="">
                Create Training
            </div>
        </div>
        <div class="scrolling-container">
            <div class="d-flex flex-column gap-3 mainUserContainer">
                <div id="createUserContainer" class="tabcontent1">
                    <div>
                        <div class="w-100">
                            <label for="inputName" class="form-label main-form-label">Name<span style="color: red">*</span></label>
                            <input type="text" @input="checkName"
                                v-model="training.name" class="custom-input form-control" id="inputName" placeholder="Name">
                            <span class="errFront text-danger" v-if="errorFront">*Required</span>
                            <div class="err" v-if="errors['name'].length > 0" style="position: absolute;">
                                <div v-for="msg in errors['name']" class="text-danger">{{msg}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="createUserContainer2" class="tabcontent2">
                    <div class="d-flex tab-content-second-section">
                        <div class="d-flex w-50 left-tab-content">
                            <div class="w-50">
                                <div class="use-template-container">
                                    <label class="form-label">Template to Use<span style="color: red">*</span></label>
                                    <Multiselect
                                        v-model="training.template_id"
                                        :options="templates"
                                        @change="checkTemplate"
                                        @close="clearTemplate"
                                        id="template_id1"
                                        placeholder="Template to Use"
                                        ref="templateRefs"
                                    />
                                    <span class="errFront text-danger" v-if="errorFront2">*Required</span>
                                </div>
                            </div>
                            <div class="w-50">
                                <label for="training_type" class="form-label">Training Type<span style="color: red">*</span></label>
                                <select id="template_id2" @change="checkParticipantType" class="form-select" v-model="training.training_type">
                                    <option value="null" disabled selected>Choose Training Type</option>
                                    <option value="public">Public</option>
                                    <option value="private">Private</option>
                                </select>
                                <span class="errFront text-danger" v-if="errorFront3">*Required</span>
                            </div>
                        </div>

                        <div class="w-50">
                            <label class="form-label">Training Time</label>
                            <div class="d-flex cssRangDates">
                                <div class="form-check w-50">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault1" @click="showRangeDates" v-model="training.date_type" value="1" checked>
                                    <label class="form-check-label" for="flexRadioDefault1">
                                        Range of Dates
                                    </label>
                                </div>
                                &nbsp;&nbsp;&nbsp;
                                <div class="form-check w-50">
                                    <input class="form-check-input" type="radio" name="flexRadioDefault2" id="flexRadioDefault2" v-model="training.date_type" value="2" @click="showSpecificDates">
                                    <label class="form-check-label" for="flexRadioDefault2">
                                        Specific Date and Time
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="w-100 d-flex align-items-end add-template-link">
                        <router-link v-if="permissions.includes('create template')" to="/templates/create" style="color: #e65c00;">
                            <span style="color: #e65c00;">Add Template</span>
                        </router-link>
                    </div>
                    <div>
                        <div class="w-100" v-if="isActivatedSpecific === true">
                            <div class="d-flex specific-dates-container">
                                <div class="w-50">
                                    <h4 class="main-form-label">Select Date</h4>
                                    <div class="specificDate-active-date-section">
                                        <label class="secondary-form-label">Date<span style="color: red">*</span></label>
                                        <Datepicker class="datepicker-container" format="MM/dd/yyyy" @update:modelValue="checkDatesEndSpecific" :minDate="new Date()" v-model="training.end_date"></Datepicker>
                                        <span class="errFront text-danger" v-if="errorFront7">*Required</span>
                                    </div>
                                </div>
                                <div class="durationSpecificCssTime specificDate-active-duration-section"></div>
                            </div>

                            <div class="w-100">
                                <div class="allCssTime d-flex">
                                    <div class="firstCssTime w-50">
                                        <div class="d-flex position-relative">
                                            <h4 class="main-form-label">Select Time</h4>
                                            <!-- <span class="fontInfoData position-absolute">
                                                <font-awesome-icon @mouseover="showDefaultUser" @mouseleave="hideDefaultUser" class="styleDesignCircleInfo" :icon="['fas', 'circle-info']" size="lg"/>
                                            </span>
                                            <span id="defaultUser" class="designDefaultUser">Time should be save in UTC</span> -->
                                        </div>
                                        <div class="second-time-input">
                                            <label class="secondary-form-label">Start Time in GMT<span style="color: red">*</span></label>
                                            <Datepicker class="datepicker-container" :is24="false" @update:modelValue="setStartTime" :timePicker="true" v-model="start_time" utc></Datepicker>
                                            <span class="errFront text-danger" v-if="errorFront8">*Required</span>
                                        </div>
                                    </div>
                                    <div class="secondCssTime w-50">
                                        <label class="secondary-form-label">End Time in GMT<span style="color: red">*</span></label>
                                        <Datepicker class="datepicker-container" :is24="false" :timePicker="true" @update:modelValue="setEndTime" v-model="end_time" utc></Datepicker>
                                        <span class="errFront text-danger" v-if="errorFront9">*Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="d-flex range-dates-container" v-if="isActivatedRange === true">
                            <div class="w-50">
                                <h4 class="main-form-label">Select Date</h4>
                                <div class="allCssDate w-100">
                                    <div class="firstDateStyle1">
                                        <label class="secondary-form-label">Start Date<span style="color: red">*</span></label>
                                        <Datepicker class="datepicker-container" format="MM/dd/yyyy" :minDate="new Date()" @update:modelValue="checkDates1" v-model="training.start_date"></Datepicker>
                                        <span class="errFront text-danger" v-if="errorFront4">*Required</span>
                                    </div>
                                    <div class="secondDateStyle2">
                                        <label class="secondary-form-label">End Date<span style="color: red">*</span></label>
                                        <Datepicker class="datepicker-container" format="MM/dd/yyyy" :minDate="minToday" @update:modelValue="checkDates2" v-model="training.end_date"></Datepicker>
                                        <span class="errFront text-danger" v-if="errorFront5">*Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="select-duration-range">
                                <h4 class="main-form-label">Select Duration</h4>
                                <div class="cssDuration">
                                    <label class="secondary-form-label">Duration in Minutes<span style="color: red">*</span></label>
                                    <input type="number" v-model="training.duration" class="form-control styleFirstTime" @input="preventMinusValue">
                                    <span class="errFront text-danger" v-if="errorFront6">*Required</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end next-btn-container">
                <router-link class="back-route" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/trainings'">
                    <button class="next-btn back-btn h-100">Back</button>
                </router-link>
                <button @click.prevent="SaveTraining" v-if="permissions.includes('create training')" :class="[{notAllowed:errorBtnSubmit}]" class="next-btn btn-container" ref="buttonSaveData">Save</button>
            </div>
        </div>
    </div>

    <AssignUsers @clickAssign="clickAssignHandler" v-if="this.isShow" :message="confirmMessage" :confirmUsers="ChooseUsers" :confirmTeam="ChooseTeam"
                 :confirmTeamLeader="ChooseTeamLeader"/>

    <ModalChooseUser @close-modal="closeModalHandler" v-if="this.isAssignFlag"  :message="chooseMessageText" :data="data" :AssignUsers="AssignUsers" />

    <AlartModal v-if="showModal" :message="message" :imagePath="ImagePath" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import SaveBtn from '../../components/SaveBtn';
    import training from "../../../api-services/training";
    import changeHandler from '../../../validation/userValidation';
    import AlartModal from "../../components/AlartModal";
    import ConfirmationModal from '../../components/ConfirmationModal';
    import AssignUsers from "../../components/AssignUsers";
    import ModalChooseUser from '../../components/ModalChooseUsers';
    import {computed} from "vue";
    import repository from "../../../api-services/repository";
    import moment from "moment";
    import competition from "../../../api-services/competition";
    import Multiselect from '@vueform/multiselect';
    import Datepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    export default {
        name:'create-training',
        props:['ChooseUsers' , 'ChooseTeam' , 'ChooseTeamLeader' , 'AssignUsers'],
        components:{
            ConfirmationModal,
            AlartModal,
            SaveBtn,
            AssignUsers,
            ModalChooseUser,
            Multiselect,
            Datepicker
        },
        data(){
            return{
                changeHandler,
                isShow:false,
                errorFront:false,
                errorFront2:false,
                errorFront3:false,
                errorFront4:false,
                errorFront5:false,
                errorFront6:false,
                errorFront7:false,
                errorFront8:false,
                errorFront9:false,
                errorBtnSubmit:false,
                isAssignFlag: false,
                start_time:null,
                end_time:null,
                confirmModalFlag: false,
                confirmModalFlag2: false,
                isActivatedRange:true,
                permissions:[],
                isActivatedSpecific:false,
                minToday:'2022/01/01',
                firstTimeInDay:'00:00',
                lastTimeInDay:'23:59',
                data: [],
                training: {
                    name:null,
                    type:2,
                    participant_type:null,
                    training_type:null,
                    date_type:1,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null,
                    template_id:null
                },
                errors:{
                    name:[],
                    type:[],
                    participant_type:[],
                    date_type:[],
                    start_date:[],
                    end_date:[],
                    duration:[],
                    isError: false
                },
                templates:[],
                ImagePath:'',
                showModal:false,
                message:null,
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    name: false,
                    user_email: false,
                    host:false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: '',
                chooseMessageText:''
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'training');
            this.training.date_type = 1;
            this.errorBtnSubmit = true;
            await this.getTemplates();
            this.permissions = this.$store.state.auth.permissions;
            this.training.template_id = this.$route.params.template_id;
            if(this.training.template_id){
                if (process.env.VUE_ENV === 'development')
                console.log("data is", this.training.template_id);
            }else {
                this.training.template_id = null;
                if (process.env.VUE_ENV === 'development')
                console.log('no params');
            }

            let today = new Date().toISOString().split('T')[0];
            this.minToday = today;

        },
        methods:{
            showDefaultUser() {
                let message = document.getElementById('defaultUser');
                message.style.display = 'block';
            },

            hideDefaultUser() {
                let message = document.getElementById('defaultUser');
                message.style.display = 'none';
            },
            checkDatesEndSpecific(e){
                this.errorFront7 = false;
            },
            setStartTime (value) {
                if(value !== null){
                    if(value.hours < 10){
                        value.hours = '0'+value.hours;
                    }

                    if(value.minutes < 10){
                        value.minutes = '0'+value.minutes;
                    }

                    this.training.start_time = value.hours + ':' + value.minutes ;
                    let timeNow = value.hours + ':' + value.minutes;

                    if(timeNow > this.training.end_time){
                        this.end_time = null;
                        this.training.end_time = null;
                    }
                    if(timeNow === this.training.end_time){
                        this.end_time = null;
                        this.training.end_time = null;
                    }
                }else{
                    this.training.start_time = null;
                }


                this.checkErrors();

            },
            setEndTime (value) {

                if(value !== null){
                    if(value.hours < 10){
                        value.hours = '0'+value.hours;
                    }

                    if(value.minutes < 10){
                        value.minutes = '0'+value.minutes;
                    }

                    this.training.end_time = value.hours + ':' + value.minutes ;
                    let timeNow = value.hours + ':' + value.minutes;

                    if(timeNow < this.training.start_time){
                        this.start_time = null;
                        this.training.start_time = null;
                    }
                    if(timeNow === this.training.start_time){
                        this.start_time = null;
                        this.training.start_time = null;
                    }
                }else{
                    this.training.end_time = null;
                }

                this.checkErrors();
            },

            preventMinusValue(e){
                // this.errorFront6 = false;
                this.checkErrors();
                if(e.target.value === '.'){
                    e.target.value = 0;
                }
                e.target.value = Math.abs(e.target.value);
            },
            checkTimes1(e){
                if(e.target.value > this.training.end_time){
                    this.training.end_time = null;
                }
            },
            checkTimes2(e){
                if(e.target.value < this.training.start_time){
                    this.training.start_time = null;
                }
            },
            checkDates1(e){
                if(e !== null){
                    let date = new Date(e);
                    if(date.toISOString().split('T')[0] > new Date( this.training.end_date).toISOString().split('T')[0]){
                        this.training.end_date = null;
                    }
                    if(date.toISOString().split('T')[0] === new Date( this.training.end_date).toISOString().split('T')[0]){
                        this.training.end_date = null;
                    }

                    this.training.start_date = date.toISOString().split('T')[0];
                }else{
                    this.training.start_date = null;
                }

                this.checkErrors();
            },
            checkDates2(e){
                if (e !== null){
                    let date = new Date(e);
                    if(date.toISOString().split('T')[0] < new Date( this.training.start_date).toISOString().split('T')[0]){
                        this.training.start_date = null;
                    }
                    if(date.toISOString().split('T')[0] === new Date( this.training.start_date).toISOString().split('T')[0]){
                        console.log('sayed2');
                        this.training.start_date = null;
                    }

                    this.training.end_date = date.toISOString().split('T')[0];
                }else{
                    this.training.end_date = null;
                }

                this.checkErrors();
            },
            clickAssignHandler(event){
                this.isAssignFlag = true;
                this.data = event[1].data.data.data;
                this.chooseMessageText = event[0];
            },
            AssignUsers(){
                if (process.env.VUE_ENV === 'development')
                console.log('assigned');
            },

            closeModalHandler(e){
                this.isShow = false;
                this.isAssignFlag = false
            },
            AssignUserToCompetition(){
                this.isShow = true;
                this.confirmModalFlag = true;
                this.confirmMessage = 'Assign to';
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/trainings');
                }
            },
            setData(e, type){

            },
            async getTemplates(){
                try{
                    const response = await repository.getTemplates( 'asc',false, 1, true);
                    for(let i = 0 ; i < response.data.data.length ; i++){
                        this.templates.push({label: response.data.data[i].name, value:response.data.data[i].id});
                    }
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            checkParticipantType(){
                this.checkErrors();
            },
            checkTemplate(){
                this.checkErrors();
                this.errorFront2 = false;
            },
            clearTemplate(){
                this.errorFront2 = true;
            },
            checkName(){
                this.checkErrors();
            },
            checkErrors() {
                this.errorFront = false;
                this.errorFront2 = false;
                this.errorFront3 = false;
                this.errorFront4 = false;
                this.errorFront5 = false;
                this.errorFront6 = false;
                this.errorFront7 = false;
                this.errorFront8 = false;
                this.errorFront9 = false;

                if( this.training.name === '' || this.training.name === null){
                    this.errorFront = true;
                }

                if(this.training.template_id === null){
                    this.errorFront2 = true;
                }

                if(this.training.training_type === null){
                    this.errorFront3 = true;
                }

                if(+this.training.date_type === 1){

                    if( this.training.start_date === null){
                        this.errorFront4 = true;
                    }

                    if( this.training.end_date === null){
                        this.errorFront5 = true;
                    }

                    if( this.training.duration === null || this.training.duration === '' || this.training.duration === 0){
                        this.errorFront6 = true;
                    }

                }else{
                    if( this.training.end_date === null){
                        this.errorFront7 = true;
                    }

                    if( this.training.start_time === null){
                        this.errorFront8 = true;
                    }

                    if( this.training.end_time === null){
                        this.errorFront9 = true;
                    }
                }

                this.errorBtnSubmit = this.errorFront || this.errorFront2 || this.errorFront3 ||
                    this.errorFront4 || this.errorFront5 || this.errorFront6 ||
                    this.errorFront7 || this.errorFront8 || this.errorFront9;

                console.log(this.errorBtnSubmit);
            },
            async SaveTraining(){
                try{
                    if(+this.training.date_type === 1){
                        if(this.training.name == null || this.training.name === '' || this.training.template_id === null || this.training.training_type === null || this.training.start_date === null || this.training.end_date === null || this.training.duration === null || this.training.duration === '' || this.training.duration === 0) {
                            // this.errorFront = true;
                            // this.errorFront2 = true;
                            // this.errorFront3 = true;
                            // this.errorFront4 = true;
                            // this.errorFront5 = true;
                            // this.errorFront6 = true;

                            this.checkErrors();
                        }else if(this.training.start_date === this.training.end_date){
                            this.showModal = true;
                            this.ImagePath = 'close.png';
                            this.message = 'Start Date Cannot Be Equal End Date';
                        }else {
                            let duration = moment.duration(moment(this.training.end_date).diff(moment(this.training.start_date)));
                            let minutesCheck = duration.asMinutes();

                            if(this.training.duration > minutesCheck){
                                this.showModal = true;
                                this.ImagePath = 'close.png';
                                this.message = 'Check Duration Mintues between start date and end date';
                            }else{
                                const response = await training.create({
                                    name:this.training.name,
                                    type:this.training.type,
                                    training_type:this.training.training_type,
                                    template_id:this.training.template_id,
                                    date_type:this.training.date_type,
                                    start_date:this.training.start_date,
                                    end_date:this.training.end_date,
                                    start_time:this.firstTimeInDay,
                                    end_time:this.lastTimeInDay,
                                    duration:this.training.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-trainings/'+response.data.data.id});
                            }
                        }
                    }else{
                        if(this.training.end_date === null || this.start_time === null || this.end_time === null){
                            // this.errorFront7 = true;
                            // this.errorFront8 = true;
                            // this.errorFront9 = true;

                            this.checkErrors();
                        }else{
                            if(moment(this.training.end_date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')){
                                let startTime = moment(this.training.end_date).format('YYYY-MM-DD') + 'T' + this.training.start_time;
                                let endTime = moment(this.training.end_date).format('YYYY-MM-DD') + 'T' + this.training.end_time;
                                let diffD = moment.duration(moment(endTime).diff(moment(startTime))).as('minutes');
                                this.training.duration = diffD;

                                const response = await training.create({
                                    name:this.training.name,
                                    type:this.training.type,
                                    training_type:this.training.training_type,
                                    template_id:this.training.template_id,
                                    date_type:this.training.date_type,
                                    start_date:this.minToday,
                                    end_date:this.training.end_date,
                                    start_time:this.training.start_time,
                                    end_time:this.training.end_time,
                                    duration:this.training.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-trainings/'+response.data.data.id});
                            }else{
                                const response = await training.create({
                                    name:this.training.name,
                                    type:this.training.type,
                                    training_type:this.training.training_type,
                                    template_id:this.training.template_id,
                                    date_type:this.training.date_type,
                                    start_date:this.minToday,
                                    end_date:this.training.end_date,
                                    start_time:this.training.start_time,
                                    end_time:this.training.end_time,
                                    duration:this.training.duration
                                });
                                await this.$store.dispatch('setDataFlag', false);

                                this.$router.push({path: '/complete-trainings/'+response.data.data.id});
                            }
                        }
                    }
                }catch(e){
                    if (process.env.VUE_ENV === 'development')
                    console.log(e);
                }
            },
            showRangeDates(e){
                this.training.date_type = 1;
                this.isActivatedRange = true;
                this.isActivatedSpecific = false;
                this.training.end_date = null;
                this.start_time = null;
                this.end_time = null;
                this.training.start_time = null;
                this.training.end_time = null;
                this.checkErrors();
            },
            showSpecificDates(){
                this.training.date_type = 2;
                this.isActivatedRange = false;
                this.isActivatedSpecific = true;
                this.training.start_date = null;
                this.training.duration = null;
                this.training.end_date = null;
                this.checkErrors();
            }
        }
    }
</script>

<style scoped>
    .header-container{
        padding-inline: 30px;
        justify-content: left !important;
        align-items: center !important;
        height: auto !important;
        margin-bottom: 0 !important;
        text-transform: uppercase;
    }
    .header-container img{
        padding-bottom: 10px;
    }
    .next-btn-container{
        padding-inline: 30px;
        margin-top: 10px;
        justify-content: end;
        height: 35px;
        gap: 10px;
    }
    .next-btn{
        background-color:#E95626;
        font-weight: normal !important;
        font-size: 18px;
        padding: 0px 50px;
        color: white;
        border-radius: 5px;
        height: 100% !important;
    }
    
    .back-btn{
        background-color: #707070 !important;
        border: none;
        padding: 0px 50px !important;
        font-weight: normal;
        color: white;
        border-radius: 5px;
        height: 100% !important;
    }
    .use-template-container{
        width:100%;
    }
    .add-template-link{
        padding-block: 10px;
    }

    .styleInIPad{
        padding-top: 5rem;
    }
    #template_id2{
        width:100%;
    }
    .cssRangDates{
        width:100%;
    }
    .specificDate-active-date-section{
        width:100%;
    }
    .specificDate-active-duration-section{
        width:50%;
    }
    .second-time-input{
        width:100%;
    }
    .firstDateStyle1{
        width:50%;
    }
    .secondDateStyle2{
        width:50%;
    }
    .select-duration-range{
        width: 50%;
    }
    .specific-dates-container,
    .left-tab-content{
        gap:20px;
    }
    .mainUserContainer{
        background-color:#032A3A ;
        border-radius: 5px;
        margin-inline: 30px;
        padding-inline: 30px;
    }
    .form-label{
        color:#37A6A2;
    }
    .main-form-label{
        color:#37A6A2;
        font-weight: 600;
        font-size: 19px;
    }
    .secondary-form-label{
        color:#E95626;
    }
    .tab-content-second-section{
        height: 106px;
        gap:20px;
    }
    .range-dates-container{
        gap:20px;
    }
    input,
    select,
    #template_id1,
    .cssRangDates,
    .datepicker-container:deep(input)
    {
        background-color:#023144 !important ;
        border-color: #39525C !important;
        color: #FFF !important;
        font-size: 15px !important;
        border-radius: 5px;
    }

    .designDefaultUser{
        display: none;
        position: absolute;
        right: -115px;
        width: 80%;
        font-size:12px;
        background-color: #021A24;
        color: #fff;
        padding: 0.8em;
        border-radius: 10px;
    }

    .styleDesignCircleInfo{
        cursor: pointer;
    }
    .styleDesignCircleInfo:hover{
        color: #e95626;
    }

    .fontInfoData{
        position: relative;
        right: 80px;
        top: 5px;
    }

    .allowed{
        cursor: pointer;
    }

    .notAllowed{
        cursor: not-allowed;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    ::-webkit-calendar-picker-indicator {
        filter: invert(100%);
    }

    .cssFirstDateOne:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }
    .scrolling-container{
        overflow-y: auto;
        height: 70vh;
    }
    .cssFirstDateOne{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .cssSecondDateTwo:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .cssSecondDateTwo{
        background-color: #021A24;
        color: #fff;
        width:330px;
        padding: 10px;
    }

    .allCssTime{
        margin-top: 20px;
        display: flex;
        justify-content: start;
        align-items: end;
        gap:20px;
    }

    .allCssDate{
        display: flex;
        gap:20px;
    }

    .styleSecondTime:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .styleSecondTime{
        background-color: #021A24;
        color: #fff;
        width: 240px;
        padding: 10px;
        height: 40px;
        border: none;
    }

    .styleFirstTime:focus{
        background-color: transparent;
        box-shadow: 0 0 0 0;
        color: var(--input-search-color);
        width: 100%;
        padding: 10px;
        height: 40px;
        border: 1px solid #fff;
    }

    .styleFirstTime{
        background-color: transparent;
        color: var(--input-search-color);
        width: 100%;
        padding: 10px;
        height: 40px;
    }

    .cssEndDate:focus{
        background-color: #021A24;
        outline: none;
        box-shadow: 0 0 0 0;
        color: #fff;
    }

    .cssEndDate{
        background-color: #021A24;
        color: #fff;
        width:350px;
        padding: 10px;
    }
    .cssRangDates{
        border: 1px solid #04354a;
        padding: 10px;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }

    #template_id1{
        background-color: transparent;
        color: var(--input-search-color);
        display: flex;
        flex-wrap: wrap;
        height: 46px;
        width: 100%;
    }
    #template_id2{
        background-color: transparent;
        color: var(--color-template-id);
        padding: 10px;
    }

    .custom-input:focus{
        outline: none;
        box-shadow: 0 0 0 0;
        background-color: transparent;
        color: var(--input-search-color);
    }

    .custom-input{
        background-color: transparent;
        color: var(--input-search-color);
        padding: 10px;
    }
    .styleBtnCss2{
        width: 180px;
        background-color: transparent;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: 2px solid #fff;
    }
    .styleBtnCss{
        width: 180px;
        background-color: #E95626;
        color: #FFF;
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }
    .tabcontent2{
        display: block;
        padding-bottom: 20px;
        height: auto;
        /* background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border); */
        border-radius: 15px;
    }
    .back-route{
        font-size: 18px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .tabcontent2{
            height: 59vh;
        }

        .errFront{
            position: relative;
        }

        .styleInIPad{
            padding-top: 0rem;
        }

        .allCssTime{
            justify-content: start;
        }

        .firstCssTime{
            width: 25%;
        }

        .secondCssTime{
            width: 25%;
        }

        .styleFirstTime{
            width: 247px;
        }
    }


    .tabcontent1{
        display: block;
        padding-top: 30px;
        /* padding-bottom: 40px; */
        /*height: 20vh;*/
        /* background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border); */
        border-radius: 15px;
    }
</style>